<template>
<div>

    <v-btn depressed rounded class="primary text-capitalize" @click="openBulkActionPopup('deleted_at')">Delete Vendor</v-btn>
    <v-chip close class="ml-4 py-5" @click:close="onCancelSelect">
        <span class="mr-4">{{selectedCount}} Selected</span>
    </v-chip>

    <v-dialog v-model="dialog" persistent width="500" content-class="modal-class"
              overlay-opacity="0.8" transition="slide-y-transition" origin="top">
        <v-card class="">
            <v-card-title class="modal-title">
                <span v-if="form.fieldId === 'deleted_at'"><b class="fs-16">Delete Vendor</b> - {{selectedCount}} Vendor{{selectedCount>1?'s':''}} selected</span>
                <span v-else><b class="fs-16">Update {{form.fieldId}}</b> -{{selectedCount}} Customer{{selectedCount>1?'s':''}} selected</span>
            </v-card-title>
            <v-card-text class="pa-4">
                <v-form ref="form">
                    <v-row class="justify-start">
                        <v-col cols="12" class="fs-16" v-if="form.fieldId === 'deleted_at'">Are you sure, you want delete vendor ?</v-col>
                        <!--  <v-col cols="11">
                              <v-select label="Select Field" v-model="form.fieldId" outlined dense hide-details :items="fieldOptions"
                                        item-text="label" item-value="id" :rules="[v => !!v || 'Please select field']"/>
                          </v-col>  -->
                       <!-- <v-col cols="11">
                            <template v-if="form.fieldId === 'label'">
                                <v-select label="Select Label" v-model="form.fieldValue" outlined dense :items="labelOptions"
                                          item-text="label" item-value="id" :rules="[v => !!v || 'Please select label']"/>
                            </template>
                        </v-col> -->
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions class="modal-footer">
                <v-spacer></v-spacer>
                <v-btn class="elevation-0" @click="closeDialog">Cancel</v-btn>
                <v-btn class="primary text-capitalize mx-4" :loading="formLoading" dark @click="handleSubmit">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import Constants from "../../../Constants/Constants";
import moment from 'moment';
import {generate_UPDATE_RECORDS_BY_CONDITION} from "../../../graphql/mutations/Orders";
let form = { fieldId: '', fieldValue:''};

export default {
    name: "BulkActionVendor",
    props: ['filter'],
    data(){
        return{
            moment: moment,
            Constants: Constants,
            user: JSON.parse(localStorage.user),
            form: {...form},
            fieldOptions:[{id:'label', label:'Label'}],
            formLoading: false,
            toaster: {enable: false},
            dialog: false
        }
    },
    computed:{
        selectedCount(){
            return this.filter.ids==='ALL'?(this.filter.allCount-this.filter.uncheckedIds.length):this.filter.ids.length
        }
    },
    methods: {
        openBulkActionPopup(fieldId){
            this.form.fieldId = fieldId;
            this.dialog = true;
        },
        onCancelSelect(){
            this.$emit('onCancelSelect', false)
        },
        handleSubmit() {
            if (this.$refs.form.validate()) this.updateVendors()
        },
        async updateVendors(){
            this.formLoading = true;
            let v = this.filter.variables;
            let queryCondition = { deleted_at :{_is_null: true},
                _or: [{name: {_ilike: v.search}}, {vendorCode: {_ilike: v.search}}, {city: {_ilike: v.search}}] };
            if(this.filter.uncheckedIds.length) queryCondition = {...queryCondition, id: {_nin: this.filter.uncheckedIds}};

            let condition = this.filter.ids === 'ALL' ? queryCondition : {id: {_in: this.filter.ids}};
            if(this.form.fieldId === 'deleted_at') this.form.fieldValue = moment().format();

            let obj = {[this.form.fieldId]: this.form.fieldValue, updatedBy: this.user.id};
            await this.updateRecords(condition, obj, 'Vendors');
            this.formLoading = false;
            this.toaster = {color:'green', enable:true, message: `Vendors ${this.form.fieldId==='deleted_at'?'Deleted':'Updated'} Successfully`};
            this.closeDialog();
            this.$emit('onCancelSelect', false);
            this.$emit('showToast', this.toaster);
        },
        async updateRecords(condition, obj, table){
            let response = await this.$apollo.mutate({
                mutation: generate_UPDATE_RECORDS_BY_CONDITION(table),
                variables: { condition, obj }
            })
            if(response.data) return Promise.resolve(response.data)
        },
        closeDialog() {
            this.$refs.form.resetValidation();
            this.form = {...form};
            this.dialog = false
        }
    }
}
</script>

<style>
.modal-class{
    margin-bottom: 54vh !important;
    border-radius: 10px;
}
.modal-title{
    font-size: 14px !important;
    background: #fbfcfd;
    border-bottom: 1px solid #eff1f3;
}
.modal-footer{
    background: #fbfcfd;
    border-top: 1px solid #eff1f3;
}
.fs-16{
    font-size: 16px;
}
</style>